module.exports = __webpack_public_path__ + "media/images/icon/arrow-751bd68dd6c6b3427e54fca44fa2aa65.png";